export const headerAccessesTable : string[] = ['Usuário','Tipo','Email','Telefone','Empresa']

export const accessesTableRequiredFields : string[] = ['name','adminUser','email','phone','company']

// Headers e permissões para tenant Industrial (padrão)
export const headerProfilesTable : string[] = ['Nome do perfil','Certificados','Estoque','Pedidos','Produção','Roteirização','Acessos', 'Produtos', 'Insumos', 'Serviços', 'Equipamentos', 'Editar estoque', ''] 

export const allPermissions : string[] = ['name','certificates','stock','orders','production','router','accesses', 'products', 'resources', 'services', 'equipment', 'edit-stock', 'delete']

// Headers e permissões específicas para tenant Fashion (tenantId 2)
export const headerProfilesTableFashion : string[] = ['Nome do perfil', 'Acessos', 'Produtos', 'Pedidos Fashion', 'Produção Fashion', 'Equipamentos', ''] 

export const allPermissionsFashion : string[] = ['name', 'accesses', 'products', 'orders', 'production', 'equipment', 'delete']

// Função para obter headers baseado no tenant
export function getHeadersByTenant(tenantId: number): string[] {
  if (tenantId === 2) {
    return headerProfilesTableFashion
  }
  return headerProfilesTable
}

// Função para obter permissões baseado no tenant
export function getPermissionsByTenant(tenantId: number): string[] {
  if (tenantId === 2) {
    return allPermissionsFashion
  }
  return allPermissions
}

export const headerCompanies : string[] = ['CNPJ','Razão social','Inscrição Estadual','Telefone','E-mail','Nome do contato', 'Tipo']

export const companiesFields : string[] = ['cnpj','companyName','stateRegistration','phone','email','contactName', 'companyTypes']